import { render, staticRenderFns } from "./DynamicAttributeAddResourceAction.vue?vue&type=template&id=8897b7e4&"
import script from "./DynamicAttributeAddResourceAction.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeAddResourceAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports